// @flow
import type { FluxStandardAction } from 'modules/helper';
import { RentalActionTypes } from './actionTypes';
import { ProductActionTypes } from 'modules/productBrowser/actionTypes';
import { RestaurantActionTypes } from 'modules/restaurant/actionTypes';

const getInitialActiveFilterState = () => {
  return {
    location: [],
    propertyType: [],
    beds: undefined,
    area: [],
    range: [],
  };
};

const initialState = {
  rentals: null,
  rentalFeature: null,
  banner: null,
  filters: null,
  adData: null,
  activeFilters: [],
  loading: {
    rentals: false,
    rentalFeature: false,
    banner: false,
  },
  error: {
    rentalFeature: null,
    rentals: null,
    banner: null,
  },
};

const toggleArrayItem = (value: number, arr: Array<number>): Array<number> => {
  const filterSet = new Set(arr);
  if (filterSet.has(value)) {
    filterSet.delete(value);
  } else {
    filterSet.add(value);
  }
  return Array.from(filterSet);
};

const updateActiveFilters = (
  payload: { type: string, value: number },
  filters
) => {
  const newFilters = { ...filters };
  const value = payload.value;
  switch (payload.type) {
    case 'beds':
      newFilters.beds = value;
      break;
    case 'range':
      newFilters.range = value;
      break;
    case 'area':
      newFilters.area = value;
      break;
    case 'location':
      newFilters.location = toggleArrayItem(value, newFilters.location);
      break;
    case 'propertyType':
      newFilters.propertyType = toggleArrayItem(value, newFilters.propertyType);
      break;
    default:
      break;
  }

  return newFilters;
};

export const RentalReducer = (
  state = initialState,
  action: FluxStandardAction
) => {
  const { type, payload, error } = action;
  switch (type) {
    case RentalActionTypes.RENTAL.FETCH:
      return {
        ...state,
        loading: { ...state.loading, rentals: true },
        error: { ...state.error, rentals: null },
      };
    case RentalActionTypes.RENTAL.SUCCESS:
      return {
        ...state,
        rentals: payload,
        loading: { ...state.loading, rentals: false },
      };
    case RentalActionTypes.RENTAL.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, rentals: false },
        error: { ...state.error, rentals: error },
      };
    //  rental detail
    case RentalActionTypes.RENTAL_DETAIL.FETCH:
      return {
        ...state,
        loading: { ...state.loading, banner: true },
        error: { ...state.error, banner: null },
      };
    case RentalActionTypes.RENTAL_DETAIL.SUCCESS:
      return {
        ...state,
        banner: payload,
        loading: { ...state.loading, banner: false },
      };
    case RentalActionTypes.RENTAL_DETAIL.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, banner: false },
        error: { ...state.error, banner: error },
      };
    // Rental filters
    case RentalActionTypes.RENTAL_FILTERS.INITIALIZE:
      return {
        ...state,
        filters: payload,
        activeFilters: Object.assign({}, getInitialActiveFilterState()),
      };
    case RentalActionTypes.RENTAL_FILTERS.TOGGLE_FILTER:
      const activeFilters = updateActiveFilters(payload, state.activeFilters);
      return {
        ...state,
        activeFilters: { ...activeFilters },
      };
    case RentalActionTypes.RENTAL_FILTERS.CLEAR_FILTERS:
      return {
        ...state,
        activeFilters: Object.assign({}, getInitialActiveFilterState()),
      };
    //feature
    case RentalActionTypes.RENTALFEATURE.FETCH:
      return {
        ...state,
        loading: { ...state.loading, rentalFeature: true },
        error: { ...state.error, rentalFeature: null },
      };
    case RentalActionTypes.RENTALFEATURE.SUCCESS:
      return {
        ...state,
        rentalFeature: payload,
        loading: { ...state.loading, rentalFeature: false },
      };
    case RentalActionTypes.RENTALFEATURE.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, rentalFeature: false },
        error: { ...state.error, rentalFeature: error },
      };
    //  ad data
    case RentalActionTypes.RENTAL_ADVERT.SUCCESS:
      return {
        ...state,
        adData: payload,
      };
    default:
      return state;
  }
};
